<template>
  <div class="water-record">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      <template slot="search_recordDate">
        <div>
          <el-date-picker v-model="recordDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
        </div>
      </template>
      <template slot="menuLeft">
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
          新增仪表
        </el-button>
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-edit-outline"
          @click="batchRecord">
          手动录入
        </el-button>
      </template>
      <template slot="recordDate" slot-scope="scope">
        <span v-if="scope.row.records.length > 0">{{ (scope.row.records[0].recordDate).substr(0, 10) }}</span>
      </template>
      <template slot="recordValue" slot-scope="scope">
        <span v-if="scope.row.records.length > 0">{{ scope.row.records[0].recordValue }}</span>
      </template>
      <template slot="currentValue" slot-scope="scope">
        <span v-if="scope.row.records.length > 0">{{ scope.row.records[0].currentValue }}</span>
      </template>
      <template slot="currentNum" slot-scope="scope">
        <span v-if="scope.row.records.length > 0">{{ Number(scope.row.records[0].currentValue) -
          Number(scope.row.records[0].recordValue) }}</span>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-view" @click="detailShow(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="录入" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-edit-outline" @click="manualEntry(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-delete" @click="deleteRecord(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog :title="dialogTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
      width="35%">
      <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
        <el-form-item label="仪表编号" prop="waterCode">
          <el-input v-model="addForm.waterCode" placeholder="请输入" :disabled="addForm.waterId != null"></el-input>
        </el-form-item>
        <el-form-item label="仪表名称" prop="waterName">
          <el-input v-model="addForm.waterName" placeholder="请输入" :disabled="addForm.waterId != null"></el-input>
        </el-form-item>
        <el-form-item label="仪表类型" prop="waterType">
          <el-select v-model="addForm.waterType" placeholder="请选择" style="width: 100%;"
            :disabled="addForm.waterId != null">
            <el-option v-for="item in waterTypeArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仪表位置" prop="waterPosition">
          <el-input v-model="addForm.waterPosition" placeholder="请输入" :disabled="addForm.waterId != null"></el-input>
        </el-form-item>
        <el-form-item v-if="addForm.waterId" label="抄表日期" prop="recordDate">
          <el-date-picker v-model="addForm.recordDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"
            style="width: 100%;" @change="recordDateChange"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="addForm.waterId" label="抄表人" prop="recordPerson">
          <el-autocomplete v-model="addForm.recordPerson" :fetch-suggestions="querySearch" placeholder="请输入" clearable
            style="width: 100%;" />
        </el-form-item>
        <el-form-item v-if="addForm.waterId" label="上期读数" prop="recordValue">
          <el-input v-model="addForm.recordValue" placeholder="请输入" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="addForm.waterId" label="本期读数" prop="currentValue">
          <el-input v-model="addForm.currentValue" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- <el-form-item v-if="addForm.waterId && addForm.compareValue" label="下期读数" prop="compareValue">
          <el-input v-model="addForm.compareValue" placeholder="请输入" disabled></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
        <el-button @click="addCancel('addForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="传统水表抄表记录录入" :visible.sync="batchVisible" append-to-body :close-on-click-modal="modalClose"
      width="48%">
      <el-form :model="batchForm" ref="batchForm" :rules="batchRules" :inline="true" label-width="80px">
        <el-form-item label="抄表日期" prop="recordDate">
          <el-date-picker v-model="batchForm.recordDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"
            style="width: 100%;" @change="formRecordDateChange"></el-date-picker>
        </el-form-item>
        <el-form-item label="抄表人" prop="recordPerson">
          <el-autocomplete v-model="batchForm.recordPerson" :fetch-suggestions="querySearch" placeholder="请输入"
            clearable />
        </el-form-item>
      </el-form>
      <div style="max-height: 500px; overflow-y: auto;">
        <el-table :data="batchData" stripe style="width: 100%">
          <el-table-column label="序号" type="index" width="100"></el-table-column>
          <el-table-column prop="waterCode" label="仪表编号"></el-table-column>
          <el-table-column prop="waterName" label="仪表名称"></el-table-column>
          <el-table-column label="上期读数">
            <template slot-scope="scope">
              <span v-if="scope.row.records.length > 0">{{ scope.row.recordBeforeValue ||
                scope.row.records[0].currentValue }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column prop="inputData" label="本期读数">
            <template slot-scope="scope">
              <!-- <el-input v-model="scope.row.inputData" @change="(value) => { useDataChange(value, scope.row) }"></el-input> -->
              <el-input v-model="scope.row.inputData"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="useData" label="用量">
            <template slot-scope="scope">
              {{ scope.row.useData }}
            </template>
          </el-table-column> -->
          <el-table-column prop="recordAfterValue" label="下期读数" />
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchConfirm('batchForm')">确 定</el-button>
        <el-button @click="batchCancel">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="用水详情" :visible.sync="detailVisible" append-to-body :close-on-click-modal="modalClose" width="48%">
      <el-form :model="detailForm" ref="detailForm" :inline="true" label-width="90px">
        <el-form-item label="仪表编号：">
          <span style="color: #303133;">{{ detailForm.waterCode }}</span>
        </el-form-item>
        <el-form-item label="仪表名称：" style="margin-left: 50px;">
          <span style="color: #606266;">{{ detailForm.waterName }}</span>
        </el-form-item>
        <el-form-item label="仪表位置：" style="margin-left: 50px;">
          <span style="color: #606266;">{{ detailForm.waterPosition }}</span>
        </el-form-item>
      </el-form>
      <div style="max-height: 500px; overflow-y: auto;">
        <el-table :data="detailData" stripe style="width: 100%">
          <el-table-column label="序号" type="index" width="100"></el-table-column>
          <el-table-column prop="recordDate" label="记录时间">
            <template slot-scope="scope">
              <span>{{ (scope.row.recordDate).substr(0, 10) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="抄表读数">
            <template slot-scope="scope">
              <span v-if="!scope.row.editFlag">{{ scope.row.currentValue }}</span>
              <el-input v-else v-model="scope.row.currentValue"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="recordPerson" label="抄表人"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-if="!scope.row.editFlag" type="text" @click="detailUpdate(scope.row)">修改</el-button>
              <el-button v-if="scope.row.editFlag" type="text" @click="detailSave(scope.row)">保存</el-button>
              <el-button v-if="scope.row.editFlag" type="text" @click="detailCancel(scope.row)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import tableOption from "../config/waterRecord";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      recordDate: null,
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        waterCode: [{ required: true, message: '请输入仪表编号', trigger: ['blur', 'change'] }],
        waterName: [{ required: true, message: '请输入仪表名称', trigger: ['blur', 'change'] }],
        waterType: [{ required: true, message: '请选择仪表类型', trigger: ['blur', 'change'] }],
        recordDate: [{ required: true, message: '请选择抄表日期', trigger: ['blur', 'change'] }],
        currentValue: [{ required: true, message: '请输入本期读数', trigger: ['blur', 'change'] }],
      },
      batchRules: {
        recordDate: [{ required: true, message: '请选择抄表日期', trigger: ['blur', 'change'] }],
      },
      dialogTitle: '',
      addVisible: false,
      modalClose: false,
      addForm: {
        waterId: null,
        waterCode: '',
        waterName: '',
        waterType: '',
        waterPosition: '',
        recordDate: '',
        recordPerson: '',
        recordValue: '',
        currentValue: '',
        compareValue: null
      },
      waterTypeArr: [{ 'label': '智能水表', 'value': '0' }],
      batchForm: {
        recordDate: '',
        recordPerson: '',
      },
      batchVisible: false,
      batchData: [],
      detailVisible: false,
      detailForm: {
        waterCode: '',
        waterName: '',
        waterPosition: ''
      },
      detailData: [],
      personData: [],
      compareData: {
        recordValue: null,
        compareValue: null,
        compareMap: []
      }
    };
  },
  created() {
    this.getList();
    this.getPersonList();
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.personData;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    getPersonList() {
      this.$fetch(api.waterRecord.personList).then((response) => {
        if (response.success) {
          this.personData = response.returnObj ? response.returnObj.map(v => {
            return {
              value: v
            }
          }) : []
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.recordDate = null
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        waterName: this.searchForm.waterName,
        recordDate: this.recordDate
      };
      this.$fetch(api.waterRecord.queryMeterList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增仪表'
      this.addForm.waterId = null
      this.addForm.waterCode = ''
      this.addForm.waterName = ''
      this.addForm.waterType = ''
      this.addForm.waterPosition = ''
      this.addVisible = true;
    },
    addCancel(formName) {
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.currentValue < 0) {
            this.$message.warning(`输入数据不能小于0`)
            return
          }
          if (this.addForm.compareValue) {
            if (this.addForm.compareValue < this.addForm.currentValue) {
              this.$message.warning(`下期读数为${this.addForm.compareValue}，本期读数不能大于下期读数`)
              return
            }
          }
          if (this.addForm.recordValue) {
            if (this.addForm.recordValue > this.addForm.currentValue) {
              this.$message.warning("本期读数不能小于上期读数")
              return
            }
          }
          if (this.addForm.waterId) {
            let params = {
              waterId: this.addForm.waterId,
              recordDate: this.addForm.recordDate + ' 00:00:00',
              recordPerson: this.addForm.recordPerson,
              currentValue: this.addForm.currentValue
            }
            this.$fetch(api.waterRecord.addSingleRecord, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              waterCode: this.addForm.waterCode,
              waterName: this.addForm.waterName,
              waterType: this.addForm.waterType,
              waterPosition: this.addForm.waterPosition
            }
            this.$fetch(api.waterRecord.addMeter, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    // 单条录入
    manualEntry(row) {
      this.getPersonList();
      this.dialogTitle = '水表抄表记录录入'
      this.addForm.waterId = row.waterId
      this.addForm.waterCode = row.waterCode
      this.addForm.waterName = row.waterName
      this.addForm.waterType = row.waterType
      this.addForm.waterPosition = row.waterPosition
      if (row.records.length > 0) {
        this.addForm.recordValue = row.records[0].currentValue
      } else {
        this.addForm.recordValue = 0
      }
      this.addForm.recordDate = ''
      this.addForm.recordPerson = ''
      this.addForm.currentValue = ''
      this.addForm.compareValue = null
      this.addVisible = true
    },
    recordDateChange() {
      // console.log('选择日期', this.addForm.recordDate)
      this.$fetch(api.waterRecord.querySingleRecord, {
        "waterId": this.addForm.waterId,
        "recordDate": this.addForm.recordDate + " 00:00:00"
      }).then((response) => {
        if (response.success) {
          // console.log('查询单个水表记录', response)
          this.addForm.recordValue = response.returnObj.recordBeforeValue
          this.addForm.compareValue = response.returnObj.recordAfterValue
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    // 批量录入
    batchRecord() {
      this.batchForm.recordDate = ''
      this.batchVisible = true
      this.queryBatchRecordList()
      this.getPersonList();
    },
    queryBatchRecordList() {
      let params = {};
      this.$fetch(api.waterRecord.queryBatchRecord, params).then((response) => {
        if (response.success) {
          let tempData = response.returnObj
          for (let i = 0; i < tempData.length; i++) {
            tempData[i].inputData = null
            tempData[i].useData = null
          }
          this.batchData = tempData;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    formRecordDateChange() {
      this.$fetch(api.waterRecord.queryFormRecord, {
        "queryRecordDate": this.batchForm.recordDate,
      }).then((response) => {
        if (response.success) {
          // console.log('查询表单录入记录', response)
          for (let i = 0; i < response.returnObj.length; i++) {
            response.returnObj[i].inputData = null
            response.returnObj[i].useData = null
          }
          this.batchData = JSON.parse(JSON.stringify(response.returnObj))
          console.log('this.batchData', this.batchData)
          this.compareData.compareMap = new Map()
          response.returnObj.forEach(item => {
            this.compareData.compareMap.set(item.waterId, { ...item })
          })
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    batchConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let editFlag = false
          let flagMsg = ''

          for (let i = 0; i < this.batchData.length; i++) {
            let { inputData, recordAfterValue, recordBeforeValue, waterName } = this.batchData[i]
            if (inputData) {
              if (inputData < 0) {
                flagMsg = '输入数据不能小于0'
                editFlag = true
                break
              }
              if (recordAfterValue && inputData > recordAfterValue) {
                editFlag = true
                flagMsg = `仪表名称为${waterName}的下期读数为${recordAfterValue}，本期读数不能大于下期读数`
                break
              }
              if (recordBeforeValue && inputData < recordBeforeValue) {
                editFlag = true
                flagMsg = `仪表名称为${waterName}的上期读数为${recordBeforeValue}，本期读数不能小于下期读数`
                break
              }
            }
          }

          // this.batchData.forEach((item, indx) => {
          //   console.log('indx', indx)
          //   if (item.inputData) {
          //     let { recordAfterValue, recordBeforeValue, waterName } = item
          //     if (recordAfterValue && item.inputData > recordAfterValue) {
          //       editFlag = true
          //       flagMsg = `仪表名称为${waterName}的下期读数为${recordAfterValue}，本期读数不能大于下期读数`
          //       return
          //     }
          //     if (recordBeforeValue && item.inputData < recordBeforeValue) {
          //       editFlag = true
          //       flagMsg = `仪表名称为${waterName}的上期读数为${recordBeforeValue}，本期读数不能小于下期读数`
          //       return
          //     }
          //   }
          // })
          if (editFlag) {
            this.$message.warning(flagMsg)
            return
          }

          const records = this.batchData.map(item => {
            return {
              waterId: item.waterId,
              currentValue: item.inputData
            }
          })

          let params = {
            recordDate: this.batchForm.recordDate + ' 00:00:00',
            recordPerson: this.batchForm.recordPerson,
            records: records
          }
          this.$fetch(api.waterRecord.addBatchRecord, params).then((response) => {
            if (response.success) {
              this.$message.success(response.msgContent)
              this.batchVisible = false
              this.getList()
            } else {
              this.$message.error(response.msgContent);
            }
          });
        }
      })
    },
    useDataChange(value, row) {
      row.useData = Number(value) - Number(row.records.length > 0 ? row.records[0].currentValue : 0)
      if (row.useData < 0) {
        this.$message.warning("本期读数小于上期读数，请重新输入")
        return
      }
      this.batchData = JSON.parse(JSON.stringify(this.batchData))
    },
    batchCancel() {
      this.batchVisible = false
    },
    detailShow(row) {
      this.detailVisible = true
      this.querydetailList(row)
    },
    querydetailList(item) {
      this.detailForm.waterCode = item.waterCode
      this.detailForm.waterName = item.waterName
      this.detailForm.waterPosition = item.waterPosition
      let params = {
        waterId: item.waterId
      };
      this.$fetch(api.waterRecord.queryDetailList, params).then((response) => {
        if (response.success) {
          if (response.returnObj.length > 0) {
            this.detailData = response.returnObj
            this.detailData.forEach(item => {
              item.editFlag = false
            })
          } else {
            this.detailData = []
          }
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    detailUpdate(row) {
      row.editFlag = true
      this.detailData = JSON.parse(JSON.stringify(this.detailData))
      this.detailUpdateChange(row)
    },
    detailUpdateChange(row) {
      // console.log('选择日期', this.addForm.recordDate)
      this.$fetch(api.waterRecord.querySingleRecord, {
        "waterId": row.waterId,
        "recordDate": row.recordDate
      }).then((response) => {
        if (response.success) {
          // console.log('查询单个水表记录', response)
          this.compareData.recordValue = response.returnObj.recordBeforeValue
          this.compareData.compareValue = response.returnObj.recordAfterValue
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    detailSave(row) {
      if (row.currentValue < 0) {
        this.$message.warning(`输入数据不能小于0`)
        return
      }
      if (this.compareData.compareValue) {
        if (this.compareData.compareValue < row.currentValue) {
          this.$message.warning(`下期读数为${this.compareData.compareValue}，本期读数不能大于下期读数`)
          return
        }
      }
      if (this.compareData.recordValue) {
        if (this.compareData.recordValue > row.currentValue) {
          this.$message.warning(`上期读数为${this.compareData.recordValue}，本期读数不能小于上期读数`)
          return
        }
      }
      let params = {
        ...row,
        recordId: row.recordId,
        currentValue: row.currentValue
      }
      this.$fetch(api.waterRecord.updateSingleRecord, params).then((response) => {
        if (response.success) {
          row.editFlag = false
          // this.detailData = JSON.parse(JSON.stringify(this.detailData))
          this.$message.success('操作成功');
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    detailCancel(row) {
      row.editFlag = false
    },
    // 删除
    deleteRecord(row) {
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bms/water/meter/del/' + row.waterId + '.json').then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.water-record {
  width: 100%;
  height: 100%;
}
</style>
